import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import * as Yup from 'yup';
import { useDashboardFeatureFlags } from '@components';
import { Button, ModalBox, Tabs, Tooltip, useModalContext } from '@fourthwall/components';
import { BasicTab } from './BasicTab';
import * as S from './EditSectionsModal.styled';
import { PreviewTab } from './PreviewTab';
import { SettingsTab } from './SettingsTab/SettingsTab';
const validationSchema = Yup.object().shape({
    name: Yup.string().required('Section name is required'),
    description: Yup.string(),
    url: Yup.string().required('Iframe URL is required').url('Please enter a valid URL'),
});
const getInitialValues = (section) => ({
    name: section.name || '',
    description: section.description || '',
    url: section.iframeUrl || '',
    settings: section.settings || [],
});
export const EditSectionsModal = ({ title, hmac, section, onSave }) => {
    const { close } = useModalContext();
    const [activeTab, setActiveTab] = useState(0);
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const handleSubmit = (values) => {
        if (onSave) {
            const updatedSection = {
                ...section,
                name: values.name.trim(),
                description: values.description.trim(),
                iframeUrl: values.url.trim(),
                settings: values.settings,
            };
            onSave(updatedSection);
        }
        close();
    };
    const handleCancel = () => {
        close();
    };
    return (React.createElement(Formik, { initialValues: getInitialValues(section), validationSchema: validationSchema, onSubmit: handleSubmit }, ({ submitForm, values, setFieldValue }) => (React.createElement(ModalBox, { title: title, onClose: handleCancel, buttons: [
            React.createElement(Button, { label: "Cancel", appearance: "secondary", onClick: handleCancel }),
            React.createElement(Button, { label: "Save", appearance: "primary", onClick: submitForm }),
        ], size: "large" },
        React.createElement(S.Content, null,
            React.createElement(Form, null,
                React.createElement(Tabs, { defaultIndex: activeTab, onSelect: (index) => setActiveTab(index) },
                    React.createElement(Tabs.List, null,
                        React.createElement(Tabs.Item, { name: "Basic Information" }),
                        dashboardFeatureFlags.developersSectionSettings.enabled && (React.createElement(Tabs.Item, { name: "Settings" })),
                        dashboardFeatureFlags.developersSectionSettings.enabled && (React.createElement(Tabs.Item, { name: "Preview" })),
                        !dashboardFeatureFlags.developersSectionSettings.enabled && (React.createElement(Tooltip, { reference: React.createElement(S.DisabledSettingsTooltip, null, "Settings") }, "Customizing section settings is in beta. Message @jierenchen on Discord to access."))),
                    React.createElement(Tabs.Panel, null,
                        React.createElement(BasicTab, null)),
                    dashboardFeatureFlags.developersSectionSettings.enabled && (React.createElement(Tabs.Panel, null,
                        React.createElement(SettingsTab, { settings: values.settings, onSettingsChange: (settings) => setFieldValue('settings', settings) }))),
                    dashboardFeatureFlags.developersSectionSettings.enabled && (React.createElement(Tabs.Panel, null,
                        React.createElement(PreviewTab, { settings: values.settings, iframeUrl: values.url, hmac: hmac }))))))))));
};
